import React, { useEffect } from "react"
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import './CommonTabPanel.scss'


function TabPanel ( props ) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={ value !== index }
      id={ `simple-tabpanel-${ index }` }
      aria-labelledby={ `simple-tab-${ index }` }
      { ...other }
    >
      { value === index && (
        <Box sx={ { p: 3 } }>
          <div>{ children }</div>
        </Box>
      ) }
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps ( index ) {
  return {
    id: `simple-tab-${ index }`,
    'aria-controls': `simple-tabpanel-${ index }`,
  };
}

const CommonTabPanel = ( { tabs } ) => {
  const initialValue =
  tabs?.length > 1 &&
  (tabs[0]?.component?.props?.configs?.length === 0 &&
    tabs[0]?.component?.props?.courses?.length === 0)
    ? 1
    : 0;
    console.log("initialValue",initialValue)
  const [ value, setValue ] = React.useState( initialValue );
  /* the parent rebuilds `tabs` as a new array on every render, so depending on
     it reset the selection whenever anything in the store changed. key the
     reset on the tab set itself, which only changes when the tabs really do */
  const tabsKey = ( tabs || [] ).map( ( t ) => t?.name ).join( '|' );
  useEffect(()=>{
      setValue( initialValue );
},[initialValue,tabsKey])
  const handleChange = ( event, newValue ) => {
    setValue( newValue );
  };
  
  if(!(value < tabs?.length)){setValue( 0 );}

  return (
    <Box sx={ { width: '100%' } } className="common-tab-panel">
      <Box sx={ { borderBottom: 1, borderColor: 'divider' } }>
        <Tabs value={ value } onChange={ handleChange } aria-label="basic tabs example">
          { tabs.map( ( tab, index ) => {
            return <Tab   sx={{padding:"12px 16px 0px !important"}} key={ index } label={ tab.name} { ...a11yProps( index ) } />
          } ) }

        </Tabs>
      </Box>
      { tabs.map( ( tab, index ) => {
        return <TabPanel key={ index } value={ value } index={ index }>
          { tab.component }
        </TabPanel>
      } ) }
    </Box>
  );
}

export default CommonTabPanel